// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__1QPHQ","total":"Cart_total__1Jfcb","actions":"Cart_actions__3Ztbc","button--alt":"Cart_button--alt__3krgY","button":"Cart_button__2go5v"};